import script from "./SearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPage.vue?vue&type=script&setup=true&lang=js"

import "./SearchPage.vue?vue&type=style&index=0&id=a1417886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1417886"]])

export default __exports__